export const isLanguageCategory = (name = '') => /^languages?$/i.test(name.trim());

export const isLanguageBrowse = (params) =>
  params.get('browse') === 'languages' ||
  isLanguageCategory(params.get('category') || '') ||
  Boolean(params.get('language') && !params.get('category'));

export const languageBrowseUrl = (language) => {
  const params = new URLSearchParams({ browse: 'languages' });
  if (language) params.set('language', language);
  return `/shop?${params}`;
};
